export default "<app-dsm-all-updates [managementMode]=\"true\"></app-dsm-all-updates>\n";